import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const stastGeneralTableStyle = {
    group50: css`
        display: flex;
        flex: 0 0 50%;
        .viewTotal {
            font-weight: 400;
        }
        border-bottom: 1px solid white;
    `,
    tableAll: css`
        border: none !important;
    `,
    headerTable: css`
        background-color: ${colors.primary};
        border-bottom: none !important ;
        .title {
            color: white !important ;
            font-weight: 300 !important;
            border-left: 1px solid white;
            &:first-child {
                border: none !important;
            }
        }
    `,
    group100: css`
        display: flex;
        flex: 0 0 100%;

        .viewNone {
            flex: 1;
        }
    `,
    borderRight: css``,
    borderNone: css`
        border-right: none !important;
    `,

    viewValue: css`
        background-color: #e2dfdc;
    `,
    col: css`
        font-size: 14px;
        background-color: #d4cfc6;
        font-weight: 300;
        border-right: 1px solid white;
        line-height: 38px;
        padding-left: 5px;
    `,
    flex25: css`
        flex: 0 0 25%;
        max-width: 25%;
    `,
    flex50: css`
        flex: 0 0 50%;
        max-width: 50%;
    `,
};

export default stastGeneralTableStyle;
